import { ProjectGraph } from '@/components/workspace/ProjectGraph'
import { FigureFrame } from '../primitives/FigureFrame'
import type { ActivityWithExchanges } from '@/lib/types/project-graph'

interface GraphBlockProps {
  activities: ActivityWithExchanges[]
}

export function GraphBlock({ activities }: GraphBlockProps) {
  return (
    <FigureFrame
      caption="Foreground system: unit processes and exchanges, scaled to the functional unit."
      source="Project graph snapshot at report creation"
    >
      <div className="h-[420px] w-full overflow-hidden rounded-md">
        <ProjectGraph activities={activities} spectatorMode={true} />
      </div>
    </FigureFrame>
  )
}
